import { PAGES } from "@/configs/pages.config";

import { isValidSocialUrl } from "./social-url";
import { TRIAL_LINK_CLAIM_PARAM } from "./trial-link-claim";

export const FILES_URL_PARAM = "url";

type BuildFilesRedirectPathOptions = {
  trialLinkClaimToken?: string;
  fileUrl?: string;
};

type BuildAuthPagePathOptions = {
  trialLinkClaimToken?: string;
  fileUrl?: string;
};

export function buildFilesRedirectPath(options: BuildFilesRedirectPathOptions = {}) {
  const search = buildAuthRedirectSearch(options);
  const basePath = resolveWorkspacePath(options);
  return search ? `${basePath}?${search}` : basePath;
}

export function buildAuthPagePath(basePath: string, options: BuildAuthPagePathOptions = {}) {
  const search = buildAuthRedirectSearch(options);
  return search ? `${basePath}?${search}` : basePath;
}

function buildAuthRedirectSearch(options: BuildAuthPagePathOptions) {
  const searchParams = new URLSearchParams();

  const trialLinkClaimToken = options.trialLinkClaimToken?.trim();
  if (trialLinkClaimToken) {
    searchParams.set(TRIAL_LINK_CLAIM_PARAM, trialLinkClaimToken);
  }

  const fileUrl = options.fileUrl?.trim();
  if (fileUrl) {
    searchParams.set(FILES_URL_PARAM, fileUrl);
  }

  return searchParams.toString();
}

function resolveWorkspacePath(options: BuildFilesRedirectPathOptions) {
  const trialLinkClaimToken = options.trialLinkClaimToken?.trim();
  if (trialLinkClaimToken) {
    return PAGES.SOCIAL.PATH;
  }

  const trimmed = options.fileUrl?.trim();

  if (!trimmed) {
    return PAGES.FILES.PATH;
  }

  if (isValidSocialUrl(trimmed, "instagram") || isValidSocialUrl(trimmed, "tiktok")) {
    return PAGES.SOCIAL.PATH;
  }

  return PAGES.FILES.PATH;
}
